import { PickupRequestSheetInitialState } from "../../../types/operations/pickupRequestSheetInterface";
import {
  PickupRequestSheetActionTypes,
  PickupRequestSheetActions,
} from "../../actionTypes/operations/pickupRequestSheetTypes";

const initialState: PickupRequestSheetInitialState = {
  pickupRequestSheetList: [],
  pickupRequestSheetPageCount: 0,
  pickupStatus: "ALL",
  pickupType: "ALL",
  pickupRequestSheetData: {
    pickup_sheet: {
      id: 0,
      market_hiring_id: 0,
      prs_date: "",
      status: "",
      branch_id: 0,
      prq_list: [],
      prs_ref_no: "",
      controller_id: null,
      type: "",
      associated_details: {
        driver_name: "",
        driver_number: "",
        vehicle_number: "",
      },
      facility_provider_id: null,
      facility_provider_code: "",
      prs_assigned_executive_code: null,
      prs_assigned_executive_id: null,
      created_by: null,
      driver_id: null,
      vehicle_id: null,
    },
    pickup_request: [
      {
        id: 0,
        customer_id: 0,
        warehouse_id: 0,
        assigned_branch: 0,
        assigned_franchise: 0,
        hub_id: 0,
        division_id: 0,
        requested_date: "",
        actual_pickup_date: "",
        requested_time: {
          close_time: "",
          start_time: "",
        },
        contact_person: "",
        contact_number: "",
        assigned_pickup_sheet: 0,
        total_weight: 0,
        total_pcs: 0,
        package_type: "",
        remarks: null,
        is_recurring: false,
        recurring_days: [],
        status: "",
        awb_number: null,
        request_id: "",
        createdAt: "",
        updatedAt: "",
        created_by: 0,
        warehouse: {
          id: 0,
          warehouse_name: "",
          email: "",
          pincode: null,
          contact_person: "",
          contact_number: "",
          pickup_address: "",
          return_address: "",
          customer_id: 0,
        },
      },
    ],
  },
};

export default function pickupRequestSheetReducer(
  state = initialState,
  action: PickupRequestSheetActionTypes
): PickupRequestSheetInitialState {
  switch (action.type) {
    case PickupRequestSheetActions.SET_PICKUP_REQUEST_SHEET_LIST:
      return {
        ...state,
        pickupRequestSheetList: action.payload,
      };

    case PickupRequestSheetActions.SET_PICKUP_REQUEST_SHEET_PAGE_COUNT:
      return {
        ...state,
        pickupRequestSheetPageCount: action.payload,
      };

    case PickupRequestSheetActions.SET_PICKUP_STATUS:
      return {
        ...state,
        pickupStatus: action.payload,
      };

    case PickupRequestSheetActions.SET_PICKUP_TYPE:
      return {
        ...state,
        pickupType: action.payload,
      };

    case PickupRequestSheetActions.SET_PICKUP_REQUEST_SHEET_BY_ID:
      return {
        ...state,
        pickupRequestSheetData: action.payload,
      };

    default:
      return state;
  }
}
